import styled from "@emotion/styled";
import { FC, HTMLAttributeAnchorTarget } from "react";

import {
  Button,
  DesignToken,
  Heading,
  RadiusToken,
  SpacingToken,
  Text,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  image: string;
  title: string;
  description: string;
  cta: { name: string; onClick?: VoidFunction; href?: string; target?: HTMLAttributeAnchorTarget };
}

export const ForwardingTab: FC<IProps> = ({ image, title, description, cta }) => {
  return (
    <Wrapper>
      <Image src={image} alt={`${title.toLowerCase()} tab image`} />
      <Flex
        column
        alignItems="center"
        gap={withVar(SpacingToken.Spacing4)}
        padding={`${withVar(SpacingToken.Spacing4)} ${withVar(SpacingToken.Spacing5)}`}
      >
        <Heading>{title}</Heading>
        <StyledText size="lg">{description}</StyledText>
        <StyledButton kind="primary" onClick={cta.onClick} href={cta.href} target={cta.target}>
          {cta.name}
        </StyledButton>
      </Flex>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 400px;
  border: 1px solid ${withVar(DesignToken.BorderBasicPrimary)};
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
  border-radius: ${withVar(RadiusToken.Radius3)};
  margin: 0 auto;
  overflow: hidden;
`;

const StyledButton = styled(Button)`
  width: fit-content;
`;

const StyledText = styled(Text)`
  text-align: center;
  max-width: 320px;
`;

const Image = styled.img`
  width: 100%;
  aspect-ratio: 400 / 190;
`;
